module.exports = __webpack_public_path__ + "static/media/Formoplast_2018_IND_Doklad_Oditor.78d3ac1b.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/informationInversors/2019/Formoplast_2018_IND_Doklad_Oditor.pdf
// module id = 132
// module chunks = 0